import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from 'mage-components';

import { Frame, SelectorActionsheet, Typography } from '@klarna/bubble-ui';

import { text } from './constants';

const componentPropTypes = {
  currentConfig: PropTypes.object.isRequired,
};

type ComponentProps = PropTypes.InferProps<typeof componentPropTypes>;

export const Configuration: React.FC<ComponentProps> = ({ currentConfig }) => (
  <Frame>
    <Row>
      <Column columns={{ mobile: 12 }}>
        <Typography textToken="text-style/headings/titles/bold/tertiary">Configuration</Typography>
      </Column>
    </Row>
    {/* @ts-expect-error: FIXME */}
    <SelectorActionsheet
      options={Object.entries(currentConfig)
        .filter(([, v]) => typeof v === 'string' || v instanceof String)
        .map(([k, v]) => ({
          value: k,
          label: text[k]?.title(v),
          description: text[k]?.description(v),
        }))}
    />
  </Frame>
);

Configuration.propTypes = componentPropTypes;
